import {
  CSSStyles,
  CustomizeStylesOptions,
} from '../hooks/useMapTokenPropsToCSS';

const important = /!important/;
/**
 * This function is a customization function that adds `!important` to all CSS
 * properties that are not already !important. It is intended to be used with
 * the `customizeStyles` option in the `useMapTokenPropsToCSS` hook.
 *
 * @param matcher A regular expression to match the CSS property names that should have `!important` added.
 * @returns CSSStyles
 */
export const customizeStylesWithImportant = (matcher?: RegExp) => {
  return (opts: CustomizeStylesOptions): CSSStyles => {
    const { cssStyles } = opts;

    Object.keys(cssStyles).forEach((key) => {
      const value = cssStyles[key];

      if (typeof value === 'string' && important.test(value)) {
        return;
      }

      if (matcher && !matcher.test(key)) {
        return;
      }

      cssStyles[key] = `${value} !important`;
    });

    return cssStyles;
  };
};
